import React from 'react';
import { Container, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { L2DRLogoIcon } from '../../component/L2DRLogoIcon/L2DRLogoIcon';

const Accueil = function () {
    return (
        <Container>
            <Box sx={{ margin: '30px 200px 0px 200px' }}>
                <L2DRLogoIcon style={{ maxWidth: '100%' }} />
            </Box>
            <Typography variant="l2dh4">Recouvrement Legal2digital</Typography>
            <Typography variant="subtitle1">By LeanPay</Typography>
        </Container>
    );
};
export default Accueil;
